import { useEffect, useReducer, useRef } from 'react';

import { CHAT_TRACE_CONFIG, chatTraceStateMachine, createChatTraceInitialState } from './chatTraceStateMachine';

type UseChatTraceStateProps = {
  thinkingTrace?: { message: string; tool_name: string };
};

export const useChatTraceState = ({ thinkingTrace }: UseChatTraceStateProps) => {
  const [state, dispatch] = useReducer(chatTraceStateMachine, thinkingTrace?.message, createChatTraceInitialState);

  const isMountedRef = useRef(true);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    // eslint-disable-next-line fp/no-mutation -- setting timer ref
    timerRef.current = setTimeout(() => {
      if (isMountedRef.current) {
        dispatch({ type: 'long_wait_triggered' });

        setTimeout(() => {
          if (isMountedRef.current) {
            dispatch({ type: 'logo_enter_complete' });
          }
        }, CHAT_TRACE_CONFIG.timing.logoEnterMs);
      }
    }, CHAT_TRACE_CONFIG.timing.longWaitDelayMs);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    dispatch({ message: thinkingTrace?.message, type: 'trace_updated' });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when thinkingTrace changes
  }, [thinkingTrace]);

  useEffect(() => {
    // eslint-disable-next-line fp/no-mutation -- tracking mount state
    isMountedRef.current = true;
    return () => {
      // eslint-disable-next-line fp/no-mutation -- tracking mount state
      isMountedRef.current = false;
    };
  }, []);

  return {
    currentIconKey: state.currentIconKey,
    logoState: state.logoState,
    message: state.message,
    showLongWaitMessage: state.showLongWaitMessage,
  };
};
